export default {
      id: "dropdownArrow-usage",
      viewBox: "0 0 10 24",
      url: __webpack_public_path__ + "sprite.1789552432127.svg#dropdownArrow-usage",
      toString: function () {
        return this.url;
      }
    }